import { Box, Card, Skeleton, Stack } from "@mui/material";
import ProductCardSnappPayIcon from "./ProductCardSnappPayIcon";
import ProductCardSnappPayIconSkeleton from "./ProductCardSnappPayIconSkeleton";

export default function ProductCardSkeleton() {
  const borderRadius = { xs: 2, sm: 4 };

  return (
    <>
      <Card sx={{ borderRadius, height: "100%", background: "transparent" }} elevation={0}>
        <Box
          sx={{
            borderRadius,
            height: "100%",
            display: "flex",
            alignItems: "normal",
            // justifyContent: "start",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              borderRadius,
              overflow: "hidden",
              // maxHeight: 290
            }}
          >
            <Box sx={{ position: "relative", aspectRatio: 1 / 1.02, width: "100%" }}>
              <Skeleton variant="rectangular" width={"100%"} height={"100%"} style={{}} animation={"wave"} />
            </Box>
            <ProductCardSnappPayIconSkeleton />
          </Box>

          <Box sx={{ py: 1 }}>
            <Skeleton variant="text" width={"80%"} height={"20px"} animation={"wave"} />
            <Skeleton variant="text" width={"50%"} height={"20px"} animation={"wave"} />
          </Box>
          <Stack direction={"row"} alignItems={"end"} justifyContent={"space-between"} mt={"auto"} mx={0.2}>
            <Stack direction={"row"} alignItems={"end"}>
              <Stack alignItems={"end"}>
                <Skeleton variant="text" width={"120px"} height={"20px"} animation={"wave"} />
              </Stack>
            </Stack>
          </Stack>
        </Box>
      </Card>
    </>
  );
}
